import { HTMLAttributes } from "react";

import { DefinedDefaults } from "@/ui/lib/types";
import type { TIllustrationKey } from "@/ui/components/primitives/Illustration";
import splitLineImage from "@/ui/assets/illustrations/split-line.webp";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const ANIMATED_HORIZONTAL_RULE_LINE_IMAGE =
  typeof splitLineImage === "string" ? splitLineImage : (splitLineImage as { src: string }).src;

export const ANIMATED_HORIZONTAL_RULE_LINE_IMAGE_CLASS =
  "bg-[length:clamp(40px,8vw,120px)_clamp(120px,16vw,215px)]";

export const ILLUSTRATION_SIZE_CLASS_MAP = {
  default: "w-full",
  md: "max-w-[390px]",
};

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TIllustrationSize = keyof typeof ILLUSTRATION_SIZE_CLASS_MAP;

export type TAnimatedHorizontalRuleBackground = {
  top?: string;
  bottom?: string;
};

export type TAnimatedHorizontalRuleProps = {
  illustrationSize?: TIllustrationSize;
  illustration: TIllustrationKey;
  background?: TAnimatedHorizontalRuleBackground;
} & HTMLAttributes<HTMLElement>;

type TAnimatedHorizontalRuleDefaultProps = DefinedDefaults<
  TAnimatedHorizontalRuleProps,
  "background" | "illustrationSize"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const ANIMATED_HORIZONTAL_RULE_DEFAULTS = {
  background: {
    top: "bg-transparent",
    bottom: "bg-transparent",
  },
  illustrationSize: "default",
} satisfies TAnimatedHorizontalRuleDefaultProps;
